<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.3333 14.1667H15.5C15.04 14.1667 14.6666 13.7933 14.6666 13.3333V9.16666C14.6666 8.70666 15.04 8.33333 15.5 8.33333H16.3333C17.2541 8.33333 18 9.07916 18 10V12.5C18 13.4208 17.2541 14.1667 16.3333 14.1667Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.5 14.1667H4.66667C3.74583 14.1667 3 13.4208 3 12.5V10C3 9.07916 3.74583 8.33333 4.66667 8.33333H5.5C5.96 8.33333 6.33333 8.70666 6.33333 9.16666V13.3333C6.33333 13.7933 5.96 14.1667 5.5 14.1667Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.9167 8.33333V7.91667C15.9167 4.925 13.4917 2.5 10.5 2.5V2.5C7.50837 2.5 5.08337 4.925 5.08337 7.91667V8.33333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0208 17.7083H9.97917C9.40417 17.7083 8.9375 17.2417 8.9375 16.6667V16.6667C8.9375 16.0917 9.40417 15.625 9.97917 15.625H11.0208C11.5958 15.625 12.0625 16.0917 12.0625 16.6667V16.6667C12.0625 17.2417 11.5958 17.7083 11.0208 17.7083Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0625 16.6667H13.8333C14.7542 16.6667 15.5 15.9208 15.5 15V14.1667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
